<template>
  <div class="pdv-address-form">
     <el-divider content-position="left">Localizar destinatário</el-divider>
     <el-form ref="form" :model="ruleForm" :label-position="labelPosition"  label-width="120px">
     <el-row :gutter="12" class="pdv-form-row">
      <el-form-item class="no-margin-bottom" :label="$t('destinatario')" prop="delivery">
          <el-row class="delivery-selector-row">
            <el-col class="delivery-selector-col">
              <DeliveryList ref="deliveryList" v-model="ruleForm.delivery" :customer="ruleForm.licence" :licence="ruleForm.licence" v-on:clear="clear" />
            </el-col>
            <el-col class="delivery-save-col">
              <el-button class="delivery-save-button" type="primary" title="Salva o destinatário no sistema" @click="save()">
                <i class="fa fa-floppy-o" aria-hidden="true"></i>
                Salvar
              </el-button>
            </el-col>
          </el-row>
      </el-form-item>
    </el-row>
    
    <el-divider content-position="left">Dados do destinatário</el-divider>

    <el-row :gutter="12" class="pdv-form-row">
      <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6">
        <el-form-item :label="$t('cpf/cnpj')" prop="federalid" class="is-required">
          <el-input v-model="ruleForm.federalid" v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"
            v-on:keyup.native.enter="next" ref="federalid" data-next="name">
              <i :class="['fa', unlock('federalid') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('federalid')"></i>
          </el-input>
        </el-form-item>
      </el-col>
      
      <el-col :xs="24" :sm="12" :md="8" :lg="10" :xl="12">
        <el-form-item :label="$t('nome')" prop="name" class="is-required">
          <el-input v-model="ruleForm.name" maxlength="50" v-on:keyup.native.enter="next" ref="name" data-next="phone">
            <i :class="['fa', unlock('name') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('name')"></i>
          </el-input>
        </el-form-item>
      </el-col>
      
      <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6">
        <el-form-item :label="$t('telefone')" prop="phone" class="phone-item">
          <el-input v-model="ruleForm.phone" v-mask="['(##) ####-####', '(##) #####-####']" v-on:keyup.native.enter="next"
            ref="phone" data-next="zipcode">
            <template slot="suffix">
              <i class="fa fa-whatsapp el-input__icon wa-toggle" :class="ruleForm.whatsapp ? 'wa-on' : 'wa-off'"
                :title="ruleForm.whatsapp ? 'Notificações no WhatsApp ativadas — clique para desativar' : 'Notificações no WhatsApp desativadas — clique para ativar'"
                @click="ruleForm.whatsapp = !ruleForm.whatsapp"></i>
              <i :class="['fa', unlock('phone') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" @click="lock('phone')"></i>
            </template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="12" class="pdv-form-row">
      <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6">
        <el-form-item :label="$t('cep')" prop="cep" class="is-required">
          <el-input maxlength="9" v-model="ruleForm.cep" v-mask="'#####-###'" @blur="zipcode(ruleForm)"
            v-on:keyup.native.enter="next" ref="zipcode" data-next="address">
            <i :class="['fa', unlock('cep') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('cep')"></i>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12" :md="10" :lg="12" :xl="14">
        <el-form-item :label="$t('endereco')" prop="address">
          <el-input v-model="ruleForm.address" maxlength="50" v-on:keyup.native.enter="next" data-next="number"
            ref="address">
            <i :class="['fa', unlock('address') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('address')"></i>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="4">
        <el-form-item :label="$t('numero')" prop="number" class="is-required">
          <el-input maxlength="6" v-model="ruleForm.number" v-on:keyup.native.enter="next" data-next="neighborhood" ref="number"
            :min="0" :precision="0" :controls="false">
            <i :class="['fa', unlock('number') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('number')"></i>
          </el-input>
        </el-form-item>
      </el-col>
  </el-row>

    <el-row :gutter="12" class="pdv-form-row">
      <el-col :xs="24" :sm="12" :md="12" :lg="7" :xl="6">
        <el-form-item :label="$t('bairro')" prop="neighborhood">
          <el-input v-model="ruleForm.neighborhood" maxlength="40" v-on:keyup.native.enter="next" ref="neighborhood"
            data-next="city">
            <i :class="['fa', unlock('neighborhood') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('neighborhood')"></i>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="7">
        <el-form-item :label="$t('cidade')" prop="city">
          <el-input v-model="ruleForm.city" maxlength="40" v-on:keyup.native.enter="next" ref="city" data-next="state">
            <i :class="['fa', unlock('city') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('city')"></i>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="8" :md="12" :lg="4" :xl="4">
        <el-form-item :label="$t('estado')" prop="state">
          <el-input v-model="ruleForm.state" maxlength="2" v-on:keyup.native.enter="next" data-next="extent" ref="state">
            <i :class="['fa', unlock('state') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('state')"></i>
          </el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="16" :md="12" :lg="5" :xl="7">
        <el-form-item :label="$t('complemento')" prop="extent">
          <el-input v-model="ruleForm.extent" maxlength="40" v-on:keyup.native.enter="next" data-next="care" ref="extent">
            <i :class="['fa', unlock('extent') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('extent')"></i>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="12" class="pdv-form-row">
      <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6">
        <el-form-item :label="$t('ac')" prop="care">
          <el-input maxlength="57" v-model="ruleForm.care" v-on:keyup.native.enter="next" ref="care"
            data-next="observation">
            <i :class="['fa', unlock('care') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('care')"></i>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="12" :md="16" :lg="17" :xl="18">
        <el-form-item :label="$t('observacao')" prop="extent">
          <el-input v-model="ruleForm.observation" maxlength="100" v-on:keyup.native.enter="next" ref="observation">
            <i :class="['fa', unlock('observation') ? 'fa-unlock' : 'fa-lock', 'el-input__icon', 'lock-toggle']" slot="suffix" @click="lock('observation')"></i>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    </el-form>
  </div>
</template>
<script>

import ZipMixins from "@/xpost/mixins/zipcode";
import { i18n } from "@/plugin/i18n";
import { DeliveryService } from "@/services/delivery/delivery.services";
import DeliveryList from "@/xpost/views/register/delivery/DeliveryList";
import { CustomerService } from "@/services/customers/customers.services";

export default {
  mixins: [ZipMixins],
  name: "PdvDeliveryData",
  components: {
     DeliveryList,
  },
   props: ["customer", "labelPosition", "licence"],
  data() {
    return {
      locks: [],
      ruleForm: {
        customer: '',
        licence: '',
        delivery: '',
        federalid: '',
        name: '',
        phone: '',
        whatsapp: true,
        cep: '',
        care: '',
        observation: '',
        address: '',
        neighborhood: '',
        state: '',
        city: '',
        number: '',
        extent: '',
      }
    }
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetchCustomer();
      console.log('watch customer', v)
      if (v && !vm.ruleForm.licence) {
        vm.ruleForm.licence = vm.getLicenceId(v);
      }
      vm.fetchDeliveryList();
    },
    licence: function (v) {
      const vm = this;
      console.log('watch licence', v)
      if (v && !vm.ruleForm.licence) {
        vm.ruleForm.licence = vm.getLicenceId(v);
      }
      vm.fetchDeliveryList();
    },
    "ruleForm.delivery": function (newVal, oldVal) {
      const vm = this;
      vm.fetchDelivery();
    },
  },
  methods: {
    startup(form) {
      this.ruleForm = form;
      if (this.licence) {
        this.$set(this.ruleForm, "licence", this.getLicenceId(this.licence));
      }
      if (!Object.prototype.hasOwnProperty.call(this.ruleForm, "delivery")) {
        this.$set(this.ruleForm, "delivery", "");
      }
      this.fetchDeliveryList();
    },
    clear() {
      this.ruleForm.delivery = "";
      this.ruleForm.federalid = this.unlock('federalid') ? '' : this.ruleForm.federalid;
      this.ruleForm.name = this.unlock('name') ? '' : this.ruleForm.name;
      this.ruleForm.cep = this.unlock('cep') ? '' : this.ruleForm.cep;
      this.ruleForm.care = this.unlock('care') ? '' : this.ruleForm.care;
      this.ruleForm.observation = this.unlock('observation') ? '' : this.ruleForm.observation;
      this.ruleForm.address = this.unlock('address') ? '' : this.ruleForm.address;
      this.ruleForm.neighborhood = this.unlock('neighborhood') ? '' : this.ruleForm.neighborhood;
      this.ruleForm.state = this.unlock('state') ? '' : this.ruleForm.state;
      this.ruleForm.city = this.unlock('city') ? '' : this.ruleForm.city;
      this.ruleForm.number = this.unlock('number') ? '' : this.ruleForm.number;
      this.ruleForm.phone = this.unlock('phone') ? '' : this.ruleForm.phone;
      this.ruleForm.whatsapp = true;
      this.ruleForm.extent = this.unlock('extent') ? '' : this.ruleForm.extent;
    },
    getLicenceId(licence) {
      return licence && licence.id ? licence.id : licence;
    },
    fetchDeliveryList() {
      this.$nextTick(() => {
        if (this.$refs.deliveryList && this.ruleForm.licence) {
          this.$refs.deliveryList.fetchDepartment();
        }
      });
    },
    unlock(field) {
      return this.locks.findIndex(x => x === field) === -1;
    },
    lock(field) {
      const lockIndex = this.locks.findIndex(x => x === field);
      if (lockIndex !== -1) {
        this.locks.splice(lockIndex, 1);
      } else {
        this.locks.push(field)
      }
    },
    next(el, ev) {
      if (el.target.dataset.next && this.$refs[el.target.dataset.next]) {
        this.$refs[el.target.dataset.next].$el.getElementsByTagName('input')[0].focus();
        this.$refs[el.target.dataset.next].$el.getElementsByTagName('input')[0].scrollIntoView({
          behavior: "smooth",
        });
      } else {
        this.$emit('focus', 'objectData');
      }
    },
    focus() {
      this.$refs.federalid.$el.getElementsByTagName('input')[0].focus();
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      DeliveryService.add({
        customer: vm.customer.id,
        name: vm.ruleForm.name,
        cep: vm.ruleForm.cep,
        extent: vm.ruleForm.extent,
        address: vm.ruleForm.address,
        mail: "",
        city: vm.ruleForm.city,
        state: vm.ruleForm.state,
        neighborhood: vm.ruleForm.neighborhood,
        number: vm.ruleForm.number,
        federalId: vm.ruleForm.federalid,
        mobile: vm.ruleForm.federalid,
        phone: vm.ruleForm.phone,
      })
        .then((response) => {
          if (vm.$refs.deliveryList) vm.$refs.deliveryList.fetchDepartment();
          this.$message({
            type: "success",
            message: i18n.tc("destinatario-adicionado-sucesso"),
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());

    },
    validate() {
      const vm = this;
      return (
        vm.ruleForm.cep &&
        vm.ruleForm.address &&
        vm.ruleForm.neighborhood &&
        vm.ruleForm.city &&
        vm.ruleForm.state &&
        vm.ruleForm.number &&
        vm.ruleForm.name
      );
    },
     fetchCustomer() {
      const vm = this;
      if (!vm.$props.customer) {
        return false;
      }
      CustomerService.get(vm.$props.customer.id)
        .then((response) => {
          if (response.cardpost && response.cardpost.length == 0) {
            this.$message({
              type: "warning",
              message: "Cliente sem cartão de postagem relacionado!",
              duration: 5000,
            });
          }
        })
        .catch((error) => {
          this.$message({ 
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
  },
    fetchDelivery() {
      const vm = this;
      if (!vm.ruleForm.delivery) return false;
      vm.loading = true;
      DeliveryService.get(vm.ruleForm.delivery)
        .then((response) => {
          console.log('DeliveryService ==> ', response);
          const zipcode = response.zipcode || {};
          vm.ruleForm.cep = zipcode.zipcode || response.cep || "";
          vm.ruleForm.address = response.address || zipcode.address || "";
          vm.ruleForm.name = response.name;
          vm.ruleForm.neighborhood = response.neighborhood || zipcode.neighborhood || "";
          vm.ruleForm.city = response.city || zipcode.city || "";
          vm.ruleForm.state = response.state || zipcode.state || "";
          vm.ruleForm.number = response.number;
          vm.ruleForm.extent = response.extent;
          vm.ruleForm.phone = response.phone;
          vm.ruleForm.federalid = response.federalId || response.mobile;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  mounted() {
    const vm = this;
    if (vm.customer && vm.customer.id) {
      vm.ruleForm.customer = vm.customer.id;
    }
    if (vm.licence) {
      vm.ruleForm.licence = vm.getLicenceId(vm.licence);
    }
    vm.fetchDeliveryList();
  },
};
</script>
<style scoped>
.pdv-address-form {
  width: 100%;
}

.pdv-form-row {
  margin-bottom: 12px;
}

.pdv-address-form >>> .el-select,
.pdv-address-form >>> .el-input {
  width: 100%;
}

.delivery-selector-row {
  align-items: center;
  display: flex;
  gap: 12px;
  width: 100%;
}

.delivery-selector-col {
  flex: 1 1 auto;
  float: none;
  min-width: 0;
}

.delivery-save-col {
  flex: 0 0 110px;
  float: none;
  max-width: 110px;
}

.pdv-address-form >>> .lock-toggle {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
}

.pdv-address-form >>> .wa-toggle {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  font-size: 15px;
  transition: color 0.15s ease;
}

.pdv-address-form >>> .wa-on {
  color: #25d366;
}

.pdv-address-form >>> .wa-off {
  color: #c0c4cc;
}

/* espaço extra à direita: o campo de telefone tem dois ícones (WhatsApp + cadeado) */
.phone-item >>> .el-input__inner {
  padding-right: 52px;
}

.delivery-save-button {
  width: 100%;
}

.bottom {
  margin-top: 8px;
}

@media (max-width: 767px) {
  .pdv-form-row {
    margin-bottom: 0;
  }

  .delivery-selector-row {
    align-items: stretch;
    flex-direction: column;
  }

  .delivery-save-col {
    flex-basis: auto;
    max-width: none;
    width: 100%;
  }
}
</style>